export default "__VITE_ASSET__DXZIf8aX__"